/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorRadioButton as ResolvedLabradorRadioButton } from 'base/components/labrador/RadioButton';

export const LabradorRadioButton: typeof ResolvedLabradorRadioButton = withLabradorInstanceof((props) => {
    return <ResolvedLabradorRadioButton {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorRadioButtonProps = PropsFromComponent<typeof LabradorRadioButton>;
